import React from "react";
import AntdDropdown, {DropDownProps} from "antd/lib/dropdown";
import DropdownButton from "antd/lib/dropdown/dropdown-button";
import { withError} from '@fishx/tracker';

interface FnDropDownProps extends React.FC<DropDownProps> {
  Button: typeof DropdownButton;
}

export const Dropdown: FnDropDownProps = (props) => {
  const { overlay, ...restProps } = props;
  return <AntdDropdown overlay={overlay} {...restProps} />;
}

Dropdown.Button = DropdownButton;

Dropdown.displayName = 'Drawer';

export default withError(Dropdown);


// WEBPACK FOOTER //
// ./src/components/dropdown/index.tsx